/*
 * Woolie — Desconto de volume nativo.
 * O checkbox "Levar N e economizar X%" apenas ajusta a QUANTIDADE do formulário de
 * produto pro nível com desconto (min_qty) quando marcado, e volta pra 1 quando
 * desmarcado. O add-to-cart é o NATIVO do tema; o desconto real é um desconto
 * automático do Shopify (quantidade mínima). Sem innerHTML, sem interceptar submit.
 */
(function () {
  function init() {
    var box = document.querySelector('[data-wl-vol]');
    if (!box) return;
    var cb = box.querySelector('[data-wl-vol-cb]');
    var dataEl = box.querySelector('[data-wl-vol-data]');
    if (!cb || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var minQty = data && data.min_qty;
    if (!minQty || minQty < 2) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var qtyInput = (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
    if (!qtyInput) return;

    function setQty(val) {
      qtyInput.value = val;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    cb.addEventListener('change', function () {
      setQty(cb.checked ? minQty : 1);
    });

    // Se o cliente mexer na quantidade na mão, desmarca o nível (evita incoerência).
    qtyInput.addEventListener('change', function () {
      if (cb.checked && parseInt(qtyInput.value, 10) !== minQty) cb.checked = false;
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
